import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 9BC0DBFF-A3F6-4061-B6E1-685880D6B653
 * name battery-charging-wireless-50
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-charging-wireless-50.svg
 * tags
 * - Battery 
 * - Home Automation 
 */
export const BatteryChargingWireless50Icon = createSvgIcon(<><path d="M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3A1,1 0 0,0 2,5V21A1,1 0 0,0 3,22H13A1,1 0 0,0 14,21V5A1,1 0 0,0 13,4M12,13H4V6H12V13Z" /></>, 'BatteryChargingWireless50Icon');
export default BatteryChargingWireless50Icon